import { render, staticRenderFns } from "./menuManagement.vue?vue&type=template&id=d88adbd6&scoped=true&"
import script from "./menuManagement.vue?vue&type=script&lang=js&"
export * from "./menuManagement.vue?vue&type=script&lang=js&"
import style0 from "./menuManagement.vue?vue&type=style&index=0&id=d88adbd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88adbd6",
  null
  
)

export default component.exports